import Vue from 'vue';

export default {
  initialiseStore(state) {
    if (localStorage.getItem('agreedToPrivacy')) {
      state.groups = localStorage.getItem('agreedToPrivacy');
    }
  },
  setGroups(state, data) {
    localStorage.setItem('agreedToPrivacy', data);
    state.groups = data;
  },
  setLayout(state, data) {
    state.layout = data;
  },
  setPlays(state, data) {
    state.plays = data;
  },
  setCAPECs(state, data) {
    state.capecs = data;
  },
  setTechniques(state, data) {
    state.techniques = data;
  },
  setControls(state, data) {
    state.controls = data;
  },
  setCWEs(state, data) {
    state.cwes = data;
  },
  setUsers(state, data) {
    state.users = data;
  },
  setSelected(state, { type, data }) {
    Vue.set(state.selected, type, data);
  },
  clearSelected(state, type) {
    Vue.set(state.selected, type, {});
  },
  setPagination(state, {
    type,
    count,
    next,
    previous
  }) {
    Vue.set(state.pagination, type, { count, next, previous });
  },
  setFilterAndFormOptions(state, { type, data }) {
    Vue.set(state.formFilterOptions, type, data);
  },
  setPendingCount(state, count) {
    state.pendingApproval.count = count;
  },
  setPendingApprovals(state, { type, data }) {
    Vue.set(state.pendingApproval, type, data);
  },
  showScenarioBuilder(state, value) {
    state.scenarioBuilder.show = value;
  },
  addToScenarioBuilder(state, play) {
    const inList = state.scenarioBuilder.plays.some((ply) => ply.id === play.id);
    if (!inList) state.scenarioBuilder.plays = [...state.scenarioBuilder.plays, play];
  },
  reorderScenario(state, data) {
    const { newIndex, oldIndex } = data;
    const temp1 = state.scenarioBuilder.plays[newIndex];
    const temp2 = state.scenarioBuilder.plays[oldIndex];
    Vue.set(state.scenarioBuilder.plays, newIndex, temp2);
    Vue.set(state.scenarioBuilder.plays, oldIndex, temp1);
  },
  removeFromScenario(state, num) {
    state.scenarioBuilder.plays = state.scenarioBuilder.plays.filter((play) => play.id !== num);
  },
  changeScenarioDetails(state, data) {
    const { name, description, classification } = data;
    state.scenarioBuilder.classification = classification;
    state.scenarioBuilder.name = name;
    state.scenarioBuilder.description = description;
  },
  updateAppendices(state, { type, data }) {
    Vue.set(state.scenarioBuilder.includeAppendix, type, data);
  },
  resetScenario(state) {
    state.scenarioBuilder = {
      show: state.scenarioBuilder.show,
      classification: '',
      name: '',
      description: '',
      plays: []
    };
  },
  throwError(state, error) {
    state.apiError = { show: true, message: error };
  },
  throwAuthError(state, error) {
    state.authError = { show: true, message: error };
  },
  closeNotice(state, type) {
    if (type === 'apiError') state.apiError = { show: false, message: '' };
    else if (type === 'authError') state.authError = { show: false, message: '' };
  },
  showCrudMessage(state, { color, text, type }) {
    state.crudMessage = {
      show: true,
      color,
      text,
      type
    };
  },
  hideCrudMessage(state) {
    state.crudMessage = {
      show: false,
      color: '',
      text: '',
      type: ''
    };
  },
  loadingApiCall(state, data) {
    state.apiLoading = data;
  },
  resetState(state) {
    state.layout = 'loading-layout';
    state.plays = [];
    state.capecs = [];
    state.techniques = [];
    state.controls = [];
    state.cwes = [];
    state.objectives = [];
    state.tags = [];
    state.tools = [];
    state.selected = {
      plays: {},
      capecs: {},
      techniques: {},
      controls: {},
      cwes: {}
    };
    state.pagination = {
      play: {},
      capec: {},
      technique: {},
      control: {},
      cwe: {}
    };
    state.formFilterOptions = {
      capecs: [],
      controls: [],
      cwes: [],
      families: [],
      groups: [],
      objectives: [],
      platforms: [],
      plays: [],
      tactics: [],
      tags: [],
      techniques: [],
      tools: []
    };
    state.scenarioBuilder = {
      show: false,
      classification: '',
      name: '',
      description: '',
      plays: []
    };
    state.apiLoading = false;
    state.apiError = { show: false, message: '' };
    state.authError = { show: false, message: '' };
    state.crudMessage = {
      show: false,
      color: '',
      text: '',
      type: ''
    };
  }
};
